import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import { Snackbar } from "@mui/material";
import { FormattedMessage } from "react-intl";
import isObject from "lodash/isObject";
import get from "lodash/get";

import messages from "./messages";

const styles = {
  errorLine: {
    margin: 0,
    lineHeight: "26px",
  },
};
class SnackbarError extends React.Component {
  // eslint-disable-line react/prefer-stateless-function

  render() {
    const { error, onRequestClose } = this.props;
    const bodyStyle = {
      // backgroundColor: colorDanger,
      height: "auto",
      lineHeight: "auto",
      paddingTop: "7px",
      paddingBottom: "7px",
    };

    if (error && error.status === 429) {
      return;
    }

    return (
      <Snackbar
        style={bodyStyle}
        open={!!error}
        message={this.renderMessage()}
        autoHideDuration={6000}
        onClose={onRequestClose}
      />
    );
  }

  renderMessage() {
    const { error, customErrorMsg } = this.props;

    if (!error) {
      return "";
    }
    if (error.id) {
      return <FormattedMessage {...error} />;
    }

    if (customErrorMsg.errors) {
      const errormsgs = Object.entries(customErrorMsg.errors)
        // eslint-disable-next-line no-unused-vars
        .map(([key, value]) => {
          if (value.errorBoxMsg) {
            return (
              <p key={key} style={styles.errorLine}>
                {value.errorBoxMsg}
              </p>
            );
          }
          return (
            <p key={key} style={styles.errorLine}>
              <FormattedMessage {...value} />
            </p>
          );
        });
      return errormsgs;
    }

    const message = customErrorMsg.statusText ||
      customErrorMsg ||
      error.error ||
      error.message ||
      error.statusText ||
      error.details ||
      (isObject(error.detail) && get(JSON.parse(error.detail), "message")) ||
      error.detail || <FormattedMessage {...messages.defaultError} />;
    return message;
  }
}

SnackbarError.propTypes = {
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  customErrorMsg: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onRequestClose: PropTypes.func,
  muiTheme: PropTypes.object,
};

export default withStyles()(SnackbarError);
